import { Suspense, lazy } from 'react';
import { PageContainer } from '@/components/page-container';
import { Skeleton } from '@/components/skeleton';

// =====================================================================
// AI visibility — "/app/b/:siteId/visibility/ai[/:engine]" (WP1 Task 8).
// Thin mount wrapper: keeps SiteAiVisibility's own lazy chunk (same
// code-splitting main.tsx used pre-Task-8) rather than pulling it into this
// route module eagerly. The `:engine` param is read by SiteAiVisibility
// itself (site-ai-visibility.tsx) — this file only needs to exist at both
// URL shapes so that param is present when set.
// =====================================================================

const SiteAiVisibility = lazy(() =>
  import('@/routes/site-ai-visibility').then((m) => ({ default: m.SiteAiVisibility })),
);

export function Ai() {
  return (
    <Suspense
      fallback={
        <PageContainer>
          <Skeleton className="h-32 w-full rounded-xl" />
          <Skeleton className="h-64 w-full rounded-xl" />
        </PageContainer>
      }
    >
      <SiteAiVisibility />
    </Suspense>
  );
}
